module.exports = __webpack_public_path__ + "static/instagram-image-2-cccfdce44fa021b15c89c5085d3dd8b0.jpg";